<template>
  <div>
    <organism-report
      v-if="!isLoading"
      :isFilter="isFilter"
      :moduleOptions="moduleOptions"
      :equipmentList="equipmentList"
      :tagList="tagList"
      v-model="datepicker"
      :resourceList="resourceList"
      :fields="fields"
      :items="previewTableData"
      @clickReview="previewReportTable"
      @clickExport="exportReportByApi"
    ></organism-report>
  </div>
</template>

<script>
import OrganismReport from "@/components/organisms/OrganismReport.vue"
import {
  getResourceTypes,
  getHostname,
  getTags,
  getPreviewReport,
  getExportReport,
} from "@/api/api-module"
import mixins from "@/mixins"
import mixinsDateTime from "@/mixins/mixinsDatetime"
import { DateTime } from "luxon"
export default {
  name: "Report",
  components: {
    OrganismReport,
  },
  mixins: [mixins, mixinsDateTime],
  data() {
    return {
      isFilter: false,
      datepicker: {
        start: "",
        end: "",
      },
      moduleOptions: [
        // {
        //   title: "Web Portal",
        //   value: "WMP",
        // },
        {
          title: "Server Management",
          value: "SMS",
        },
        // {
        //   title: "Backup Management",
        //   value: "BMM",
        // },
        // {
        //   title: "Network Configuration Management",
        //   value: "NCM",
        // },
      ],
      resourceList: [],
      equipmentList: [],
      tagList: [],
      fields: [
        {
          field: "time",
          label: "TIME",
          sortable: true,
          thClass: "pl-2",
        },
        {
          field: "equipment",
          label: "EQUIPMENT",
          sortable: true,
        },
        {
          field: "resources",
          label: "RESOURCES",
          sortable: false,
        },
        {
          field: "value",
          label: "VALUE",
          sortable: true,
        },
        {
          field: "description",
          label: "DESCRIPTION",
          sortable: false,
        },
      ],
      previewTableData: [],
    }
  },
  computed: {
    isLoading() {
      return (
        !this.resourceList.length &&
        !this.equipmentList.length &&
        !this.tagList.length
      )
    },
  },
  async mounted() {
    this.isFilter = false
    this.datepicker = {
      start: DateTime.now().minus({ days: 1 }).toISO(),
      end: DateTime.now().toISO(),
      now: DateTime.now().toISO(),
    }
    await this.getResourceTypeList()
    await this.getHostnameList()
    await this.getTagList()
  },
  methods: {
    // get equipment list
    async getHostnameList() {
      this.showLoading(true)
      this.equipmentList = []
      await getHostname()
        .then((response) => {
          this.equipmentList = response
        })
        .finally(() => this.showLoading(false))
    },

    // get tags list
    async getTagList() {
      this.showLoading(true)
      this.tagList = []
      await getTags()
        .then((response) => {
          this.tagList = response
        })
        .finally(() => this.showLoading(false))
    },

    // get resource types list
    async getResourceTypeList() {
      this.resourceList = []
      await getResourceTypes().then((response) => {
        this.resourceList = response
      })
    },

    // review report table
    async previewReportTable(filter) {
      this.isFilter = true
      this.showLoading(true)
      this.previewTableData = []
      await getPreviewReport(filter)
        .then((response) => {
          response.forEach((report) => {
            this.previewTableData.push({
              id: report.eventId,
              date: DateTime.fromISO(report.timestamp).toFormat("dd/MM/yyyy"),
              time: DateTime.fromISO(report.timestamp).toFormat("HH:mm:ss"),
              equipmentName: report.equipmentName,
              tag: report.tags,
              equipmentIp: report.equipmentIpAddress,
              resources: report.resourceType,
              value: parseFloat(report.value).toFixed(1),
              description: report.equipmentDescription,
              warningValue: parseFloat(report.warningValue).toFixed(2),
              criticalValue: parseFloat(report.criticalValue).toFixed(2),
              unit: report.unit,
              status: report.status,
            })
          })
        })
        .finally(() => this.showLoading(false))
    },

    async exportReportByApi(filter) {
      this.showLoading(true)
      await getExportReport(filter).finally(() => this.showLoading(false))
    },
  },
}
</script>

<style></style>
